﻿import * as utils from "./utils";

$(function () {

    const selectedCategoryClass = "header-catalog__item--active";
    const catalogItemSelector = "js-header-catalog-item";
    const mobileDevices = utils.isTablet() || utils.isMobile() || utils.isSmallTablet();

    if (!mobileDevices) {
        $('.sidebar-list__root').hover(function () {
            $(this).find('.sidebar-list__child').css('visibility', 'visible').css('opacity', '1');
        }, function () {
            $(this).find('.sidebar-list__child').css('visibility', 'hidden').css('opacity', '0');
        });
    }

    $(".sidebar-a").on("click", function (e) {
        if (mobileDevices) {
            e.preventDefault();
            const $wrapEl = $(this).closest(".js-header-catalog-item");
            const childFrame = $wrapEl.find(".sidebar-list__child");
            if(childFrame.length === 0) {
                window.location.href = $(this).attr('data-url');
            } else {
                $(catalogItemSelector).removeClass(selectedCategoryClass);
                const categoryName = $(this).find('.header-catalog__name').text();
                childFrame.addClass('visible').css('visibility', 'visible').css('opacity', '1');
                $wrapEl
                    .addClass(selectedCategoryClass)
                    .find('.js-catalog-subtitle')
                    .text(categoryName);
            }
        } else {
            window.location.href = $(this).attr('data-url');
        }
    });

    $(".sidebar-a-name").on("click", function (e) {
        window.location.href = $(this).attr('data-url');
    });

    // hide sublist and go back
    $('.js-catalog-backlink').on('click', function () {
        const $visibleSublist = $('.sidebar-list__child.visible');
        if ($visibleSublist.length) {
            $visibleSublist.removeClass('visible').css('visibility', 'hidden').css('opacity', '0');
        }
    });
    // hide catalog popup
    $('.js-catalog-close').on('click', function () {
        const $visibleSublist = $('.sidebar-list__child.visible');
        if ($visibleSublist.length) {
            $visibleSublist.removeClass('visible').css('visibility', 'hidden').css('opacity', '0');
        }
    });

    $('.js-catalog-subtitle').on('click', function (e) {
        e.preventDefault();
    });
});
